import { useRef } from "react";
import api from "../../../services/api";
import { getImageUrl } from "../../../utils/media";
import PhotoAddIcon from "../../Metodologia/PhotoAddIcon/PhotoAddIcon";
import "./style.css";

export default function ImagePickerField({ value, onChange, alt }) {
  const fileInputRef = useRef(null);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    event.target.value = "";
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);

    try {
      const response = await api.post("/media/upload", formData);
      onChange(response.data);
    } catch (error) {
      console.error("Falha no upload da imagem", error);
    }
  };

  const imageUrl = getImageUrl(value);

  return (
    <div className="image-picker">
      <div className="image-picker__preview">
        {imageUrl ? (
          <img src={imageUrl} alt={alt || ""} />
        ) : (
          <div className="image-picker__placeholder" />
        )}
      </div>
      <button
        type="button"
        className="image-picker__botao"
        onClick={() => fileInputRef.current.click()}
        aria-label="Trocar foto"
      >
        <PhotoAddIcon />
      </button>
      <input
        type="file"
        accept="image/png, image/jpeg"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </div>
  );
}
